// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__10AU4","header":"ReportDetails_header__2whvL","title":"ReportDetails_title__2QA0p","left":"ReportDetails_left__1ez7y"};